import { Company } from "@/features/types";

export const UNO: Company = {
  id: 1,
  name: "UNO TRADING",
  type: "AGENCY",
};
